<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card class="mb-2">
          <v-card-title>
            <table>
              <tr>
                <td class="font-size--18">오늘 입금액</td>
                <td v-if="factoringPreDate" class="won color--nice font--m-3">
                  {{ factoringAmount | commaFormat }} 원
                </td>
                <td v-else class="won color--nice">0 원</td>
              </tr>
            </table>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12">
        <p class="font-size--14 mb-0 px-2">
          *입금기준 매출일자: {{ factoringStartDate }}
          <span v-if="factoringStartDate !== factoringEndDate"> ~ {{ factoringEndDate }} </span>
        </p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    date: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('earlyPayment', {
      isLoading1: 'getEarlyPaymentsLoading',
      isLoading2: 'getRefundsLoading',
      earlypayments: 'getEarlyPayments',
      refunds: 'getRefunds',
    }),
    isLoading() {
      return this.isLoading1 || this.isLoading2
    },
    refundAmount() {
      return this.refunds.reduce((accumulator, item) => accumulator + item.amount, 0)
    },
    factoringAmount() {
      return this.earlypayments?.totalTransfer ?? 0
    },
    factoringPreAmount() {
      return this.factoringAmount - this.refundAmount
    },
    factoringPreDate() {
      return this.refunds[0]?.created
    },
    factoringStartDate() {
      const f = 'MM-DD (dd)'
      const temp = this.earlypayments?.salesStartDate || this.date
      return this.$moment(temp).format(f)
    },
    factoringEndDate() {
      const f = 'MM-DD (dd)'
      const temp = this.earlypayments?.salesEndDate || this.date
      return this.$moment(temp).format(f)
    },
  },
  watch: {
    date: {
      immediate: true,
      handler(newValue) {
        this.getData(newValue)
      },
    },
  },
  methods: {
    ...mapActions('earlyPayment', ['getEarlyPayments', 'getRefunds']),
    getData(date) {
      if (!date) {
        return
      }
      this.getEarlyPayments(date)
      this.getRefunds(date)
    },
  },
}
</script>
<style lang="scss" scoped>
.v-card {
  width: 100%;
  box-shadow: none !important;

  .v-card__title {
    background-color: #f1faff;

    table {
      width: 100%;
      tr {
        td {
          width: 40%;
        }
        .won {
          width: 60%;
          text-align: right;
        }
      }
    }
  }
}
</style>
